<ckeditor
  [disabled]="false"
  [(ngModel)]="story"
  [editor]="Editor"
  [config]="config"
  (ready)="onReady($event)"
  (change)="onChange($event)"
  tagName="div"></ckeditor>
